import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cached = null;
let inflight = null;

const DEFAULTS = {
  whatsapp_supreme: "380759878825",
  whatsapp_gymgear: "380759878825",
  telegram_username: "SupremeLaboratories",
};

export function invalidateSettingsCache() {
  cached = null;
  inflight = null;
}

async function fetchSettings() {
  if (cached) return cached;
  if (!inflight) {
    inflight = axios
      .get(`${API}/settings`)
      .then((r) => {
        cached = { ...DEFAULTS, ...(r.data || {}) };
        return cached;
      })
      .catch(() => {
        cached = DEFAULTS;
        return cached;
      });
  }
  return inflight;
}

export function useSettings() {
  const [settings, setSettings] = useState(() => cached || DEFAULTS);
  useEffect(() => {
    let cancelled = false;
    fetchSettings().then((s) => {
      if (!cancelled) setSettings(s);
    });
    return () => { cancelled = true; };
  }, []);
  return settings;
}
